export const getPrivateRouteByRole = (idRol) => {
  if (String(idRol) === "1") return "/Profile";
  if (String(idRol) === "2") return "/Course";
  return "/Profile";
};

export const getUserId = (user) => user?.idUsuario ?? user?.id ?? null;

export const hasAceptadoTratamientoDatos = (user) => {
  if (!user) return false;
  const value = user.AutoTraDatos ?? user.autoTraDatos;
  return value === true || value === "true" || value === 1 || value === "1";
};
